class PaginationAjax extends HTMLElement {
  constructor() {
    super();

    this.checkHistoryAndScroll();
    this.addEventListener('click', this.handlePaginationClick.bind(this));

    const newPagination = document.getElementById('pagination-ajax-json');
    if (!newPagination) {
      this.querySelector('[paginationInfo]')?.remove();
      return;
    }

    try {
      this.paginateData = JSON.parse(newPagination.innerText);
    } catch (error) {
      console.error('Error parsing pagination data:', error);
      this.querySelector('[paginationInfo]')?.remove();
      return;
    }

    this.minPage = this.paginateData.current_page;
    this.maxPage = this.minPage;
  }

  handlePaginationClick(event) {
    if (
      event.target.tagName === 'A' &&
      (event.target.hasAttribute('paginationNext') || event.target.hasAttribute('paginationPrevious'))
    ) {
      event.preventDefault();
      const type = event.target.hasAttribute('paginationNext') ? 'next' : 'previous';
      const url = event.target.getAttribute('href');
      this.classList.add('opacity-50', 'pointer-events-none');
      this.paginationLink(type, url);
    }
  }

  async paginationLink(type, url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const productGrid = this.querySelector('#product-grid');
      const newProductCards = doc.querySelectorAll('#product-grid > li');
      const newPaginationTracker = doc.querySelector('pagination-tracker');
      const existingPaginationTracker = this.querySelector('pagination-tracker');
      if (newPaginationTracker && existingPaginationTracker) {
        existingPaginationTracker.setNewLow(newPaginationTracker.dataset.low);
        existingPaginationTracker.setNewHigh(newPaginationTracker.dataset.high);
      }

      if (type === 'next') {
        newProductCards.forEach((card) => {
          productGrid.appendChild(card);
        });
      } else {
        // Iterate in reverse order
        for (let i = newProductCards.length - 1; i >= 0; i--) {
          productGrid.prepend(newProductCards[i]);
        }
      }

      // Update the URL in the address bar
      window.history.pushState({ path: url }, '', url);

      // Update pagination links
      this.updatePaginationLinks(type, doc);

      this.classList.remove('opacity-50', 'pointer-events-none');

      window.dispatchEvent(new CustomEvent('custom:facets:fetch:complete'));
      window.dispatchEvent(new CustomEvent('custom:pagination:refresh'));

      newProductCards[0].querySelector('product-card')?.focus();

      // Update pagination info
      if (!this.paginateData) {
        return;
      }
      this.updatePaginationInfo(type);
    } catch (error) {
      console.error('Failed to fetch new page:', error);
    }
  }

  updatePaginationLinks(type, doc) {
    const nextLink = this.querySelector('[paginationNext]');
    const prevLink = this.querySelector('[paginationPrevious]');
    const newNextLink = doc.querySelector('[paginationNext]');
    const newPrevLink = doc.querySelector('[paginationPrevious]');

    if (type === 'next') {
      if (nextLink && newNextLink) {
        nextLink.setAttribute('href', newNextLink.getAttribute('href'));
      } else if (nextLink) {
        document.querySelector('[paginationinfo]')?.remove();
        nextLink.parentNode.remove();
      }
    } else {
      if (prevLink && newPrevLink) {
        prevLink.setAttribute('href', newPrevLink.getAttribute('href'));
      } else if (prevLink) {
        prevLink.parentNode.remove();
      }
    }
  }

  updatePaginationInfo(type) {
    const offsetStart = this.querySelector('[offsetStart]');
    const offsetEnd = this.querySelector('[offsetEnd]');

    // Ensure elements are present
    if (!offsetStart || !offsetEnd) {
      console.error('Pagination display elements not found');
      return;
    }

    if (type === 'next') {
      this.maxPage++;
    } else {
      this.minPage--;
    }

    const startIndex = Math.max((this.minPage - 1) * this.paginateData.page_size, 0); // Ensure it doesn't go below 0
    const endIndex = Math.min(this.maxPage * this.paginateData.page_size, this.paginateData.items);

    offsetStart.innerText = startIndex + 1; // +1 to convert from zero-based index
    offsetEnd.innerText = endIndex;
  }

  checkHistoryAndScroll() {
    let stateData = history.state || {};
    if (stateData && stateData.collection_item_id) {
      history.scrollRestoration = 'manual';
      this.querySelector(`product-card[data-id="${stateData.collection_item_id}"]`).scrollIntoView({ block: 'center' });
      delete stateData.collection_item_id;
      history.replaceState(stateData, '');
    }
  }
}

customElements.define('pagination-ajax', PaginationAjax);
